import { takeLatest, put } from 'redux-saga/effects'
import axios from 'axios'
import getAllReferencesActions, {
    getAllReferenceTypes,
} from '../../../redux/referencial/getAllReferencial'
import getDisabledReferencesActions, {
    getDisabledReferenceTypes,
} from '../../../redux/referencial/getDisabledReferenciel'
import getLoaderActions from '../../../redux/wrapApi/index'
import instance from '../../../serveur/axios'

export function renameKeys(obj) {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = obj[key].id || key.substring(30, key.length)
        return { [newKey]: obj[key] }
    })
    return Object.assign({}, ...keyValues)
}
function* getByPaginationReferencialSagas(payload) {
    let result = '?'
    Object.keys(payload).map((key, index) => {
        if (key !== 'type' && payload[key] != null) {
            if (index !== 1) {
                result += '&'
            }
            result += key
            result += '='
            result += payload[key]
        }
        return result
    })
    const response = yield instance.get(`referenciel/${result}`)
    if (response.status === 200) {
        yield put(
            getAllReferencesActions.getReferenceByPaginationSuccess(
                response.data.data
            )
        )
    } else {
        yield put(
            getAllReferencesActions.getReferenceByPaginationFailure(response)
        )
    }
}
function* getAllReferencialSagas({ response }) {
    try {
        yield put(getLoaderActions.activeGeneraleLoader())
        const responseReq = yield axios({
            method: 'get',
            url: `http://41.231.36.133:81/api/referenciel/all${response ||
                ''}`,
            headers: {
                'Accept-Version': 1,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            timeout: 60000,
        })

        if (responseReq.status === 200) {
            const referenciels = renameKeys(responseReq.data.data.referenciels)
            if (response)
                yield put(
                    getDisabledReferencesActions.getDisabledReferenceSuccess({
                        categories: responseReq.data.data.categories,
                        referenciels,
                    })
                )
            else
                yield put(
                    getAllReferencesActions.getAllReferenceSuccess({
                        categories: responseReq.data.data.categories,
                        referenciels,
                    })
                )
            yield put(getLoaderActions.disableGeneraleLoader())
        } else {
            if (response)
                yield put(
                    getDisabledReferencesActions.getDisabledReferenceFailure(
                        responseReq
                    )
                )
            else
                yield put(
                    getAllReferencesActions.getAllReferenceFailure(responseReq)
                )
            yield put(getLoaderActions.disableGeneraleLoader())
        }
    } catch (error) {
        if (response)
            yield put(
                getDisabledReferencesActions.getDisabledReferenceFailure(
                    error.toString()
                )
            )
        else
            yield put(
                getAllReferencesActions.getAllReferenceFailure(error.toString())
            )
        yield put(getLoaderActions.disableGeneraleLoader())
    }
}

export function* getAllReferencialSaga() {
    yield takeLatest(
        getAllReferenceTypes.GET_ALL_REFERENCE_REQUEST,
        getAllReferencialSagas
    )
    yield takeLatest(
        getDisabledReferenceTypes.GET_DISABLED_REFERENCE_REQUEST,
        getAllReferencialSagas
    )
    yield takeLatest(
        getAllReferenceTypes.GET_REFERENCE_BY_PAGINATION_REQUEST,
        getByPaginationReferencialSagas
    )
}
